import React from "react";
import "./Common_Back_Btn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Common_Back_Btn = ({ backText, onClick }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClick) {
      onClick(); // Custom back (Cart steps)
    } else {
      navigate(-1); // Default back (Other pages)
    }
  };

  return (
    <div
      className="Common_Back_Btn"
      onClick={handleBack}
      style={{ cursor: "pointer" }}
    >
      <FontAwesomeIcon icon={faArrowLeftLong} className="back_icon" /> {backText}
    </div>
  );
};

export default Common_Back_Btn;
